import { type PRProductSupported } from '@/domains/core/tracking/interfaces/PRProductSupported';
import { ProductCardFragment } from '@/domains/productDiscovery/Recommendation/services/graphql/generated/productCard.fragment.generated';

export const graphqlProductToPrProductMapper = (
  p: ProductCardFragment,
  itemIndex: number,
): PRProductSupported => {
  return {
    pr_article_id: p.sku.masterProduct.articleId,
    pr_model_id: p.sku.modelId,
    pr_product_id: p.productId,
    pr_seller_id: undefined,
    pr_brand_id: p.sku.masterProduct.brand?.id,
    pr_lowest_category_id: p.sku.masterProduct.masterCategoryId ?? undefined,
    pr_name: p.sku.title ?? undefined,
    pr_price: p.pricing.sellPrice.amountVatIncluded,
    pr_price_excluding_vat: p.pricing.sellPrice.amountVatExcluded,
    pr_is_sponsored: undefined,
    pr_is_mf: p.coldDeliveryOffers?.isMf,
    pr_position: itemIndex + 1,
    pr_quantity: undefined,
    pr_category_level_name_1: undefined,
    pr_category_level_name_2: undefined,
    pr_category_level_name_3: undefined,
    pr_category_level_name_4: undefined,
    pr_category_level_id_1: undefined,
    pr_category_level_id_2: undefined,
    pr_category_level_id_3: undefined,
    pr_category_level_id_4: undefined,
    pr_brand_name: p.sku.masterProduct.brand?.title,
    pr_has_a_coupon: undefined,
    pr_rating_count: p.productRating?.total,
    pr_rating: p.productRating?.average,
    pr_variant_count: p.variantsCount,
    pr_is_second_hand_product: undefined,
    pr_shipping_options: undefined,
    pr_b2b_price_advantage_count: undefined,
    pr_md_count: undefined,
    pr_is_best_quality_offer: undefined,
    pr_label: undefined,
    pr_total_ati: undefined,
  };
};
